import { css } from '@emotion/react';
import { Box } from '@spark-web/box';
import { Text } from '@spark-web/text';
import { ThemeProvider } from '@spark-web/theme';
import { FC } from 'react';

import { usePartnerConfig } from '~/context/PartnerConfigContext';
import starIcon from '~/public/icons/commbank/star.svg';
import { toSparkTheme } from '~/utils/theme';

export const LocalVendor: FC = () => {
  const config = usePartnerConfig();
  const theme = toSparkTheme(config?.configuration?.sparkThemeName);

  return (
    <ThemeProvider>
      <Box
        padding="xsmall"
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap="xxsmall"
        css={css({
          background: 'rgba(0, 210, 153, 0.5)',
        })}
      >
        <ThemeProvider theme={theme}>
          <img src={starIcon} width={14} height={14} alt="" />
          <Text size="small">Local vendor</Text>
        </ThemeProvider>
      </Box>
    </ThemeProvider>
  );
};
